// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__UZv-4","item":"FAQ_item__AnTAz","active":"FAQ_active__KW+V5","header":"FAQ_header__705Ge","icon":"FAQ_icon__xjpwz","content":"FAQ_content__mTKqa"};